
import TreeViewTab from './TreeView/TreeViewTab.vue'
import ModulesTab from './TreeView/ModulesTab.vue'
import TreeViewRightClick from './TreeViewRightClick.vue'

import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

import TreeParser from './helpers/TreeParser'
// eslint-disable-next-line no-unused-vars
import Utils from '@/lib/utils'

var globalThis = require('globalthis')() // returns native globalThis if compliant

@Component({
  computed: {
    ...mapGetters({
      getConfiguration: 'getConfiguration',
      getConfigNodesMap: 'getConfigNodesMap',
      getOpenFileContent: 'getOpenFileContent',
      getDarkMode: 'getDarkMode',
      getIDCounter: 'getIDCounter',
      getConfigLoaded: 'getConfigLoaded',
      getStartLoadingConfig: 'getStartLoadingConfig',
      getTopLevelNodeNameReferenceIDsMap: 'getTopLevelNodeNameReferenceIDsMap',
      getForcedActiveNodeType: 'getForcedActiveNodeType',
    }),
  },
  methods: {
    ...mapActions({
      setSnackBarText: 'setSnackBarText',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      clearStoreState: 'clearStoreState',
      setSelectedNodeViaID: 'setSelectedNodeViaID',
      fetchCfgFromFileOrLocalServer: 'fetchCfgFromFileOrLocalServer',
      createTreeRefsMap: 'createTreeRefsMap',
      createConfigNodesMap: 'createConfigNodesMap',
      createTopLevelNodeNameToIds: 'createTopLevelNodeNameToIds',
      createTopLevelNodeTypeToIds: 'createTopLevelNodeTypeToIds',
      createTopLevelNodeNameReferenceIDsMap:
        'createTopLevelNodeNameReferenceIDsMap',
      createTopLevelDatasetNameToIds: 'createTopLevelDatasetNameToIds',
      createTopLevelStreamNameToIds: 'createTopLevelStreamNameToIds',
      createTopLevelDatasetNameReferenceIDsMap:
        'createTopLevelDatasetNameReferenceIDsMap',
      createTopLevelStreamNameReferenceIDsMap:
        'createTopLevelStreamNameReferenceIDsMap',
      createTopLevelModuleNameChildrenIDsMap:
        'createTopLevelModuleNameChildrenIDsMap',
      createRootNodeIds: 'createRootNodeIds',
      setInitialIDCounter: 'setInitialIDCounter',
      createObjectReferences: 'createObjectReferences',
    }),
  },
  components: {
    TreeViewTab,
    ModulesTab,
    TreeViewRightClick,
  },
})
export default class TreeView extends Vue {
  @Watch('getOpenFileContent')
  // eslint-disable-next-line no-unused-vars
  onOpenFileContentChanged(val: any, oldVal: any) {
    /*    console.log('VAL:' + val)
    console.log('OLDVAL: ' + oldVal) */
    this.fetchConfigurationFromFile(val)
  }

  @Watch('getIDCounter')
  // eslint-disable-next-line no-unused-vars
  onIDCounterChanged(val: any, oldVal: any) {
    /*    console.log('getIDCounter VAL:' + val)
    console.log('getIDCounter OLDVAL: ' + oldVal) */
  }

  @Watch('getForcedActiveNodeType')
  // eslint-disable-next-line no-unused-vars
  onForcedActiveTypeChanged(val: any, oldVal: any) {
    //console.log('forcedActive type VAL:' + val)
    //console.log('forcedActive type OLDVAL: ' + oldVal)
    //this.forcedActive = [val]
    console.log('MAIN TREE CHANGING TAB TYPE TO: ' + val)
    if (val != '') this.activeTab = this.nodeTypeTab[val]
  }

  private treeRefsMap: Array<String> = [
    'sequenceTreeRef',
    'moduleTreeRef',
    'pathTreeRef',
    'endPathTreeRef',
    'psetTreeRef',
    'taskTreeRef',
    'condTaskTreeRef',
    'spTreeRef',
    'edaTreeRef',
    'espTreeRef',
    'essTreeRef',
    'servicesTreeRef',
    'streamTreeRef',
    'datasetTreeRef',
  ]

  private tabTypes: Array<string> = [
    'paths',
    'endpaths',
    'sequences',
    'modules',
    'esproducers',
    'essources:',
    'switchproducers:',
    'pset:',
    'tasks:',
    'condtasks:',
    'services',
    'dataset',
    'stream',
  ]

  private configNodesMap!: Object //ID to Node Object map
  private topLevelNodeTypeToIdMap!: Object //top level node type to Node IDs map
  private topLevelNodeNameToIdMap!: Object //top level node Name to Node ID map
  private topLevelNodeNameReferenceIDsMap!: Object //nested node name - array of IDs map
  private topLevelModuleNameToChildrenIDsMap!: Object //nested module name - array of children IDs map
  private rootNodeIds!: Object //all root node IDs map
  //Streams and Datasets
  private topLevelStreamNameToIdMap!: Object //1-1 Top Level Stream Name to Top Level ID map
  private topLevelDatasetNameToIdMap!: Object //1-1 Top Level Dataset Name to Top Level ID map
  private topLevelStreamNameReferenceIDsMap!: Object //both Streams and Datasets can have same name so we separate IDs
  private topLevelDataSetsNameReferenceIDsMap!: Object

  private sequencesId!: number
  private pathsId!: number
  private endPathsId!: number
  private modulesId!: number
  private switchProducersId!: number
  private psetsId!: number
  private tasksId!: number
  private condTasksId!: number
  private esProducersId!: number
  private esSourcesId!: number
  private servicesId!: number
  private streamsId!: number
  private datasetsId!: number
  private search: any = null
  private searchDeep: boolean = false

  private idCounter = 0 //main ID counter

  //right click menu variables
  private rightClickNodeType = ''
  private rightClkNodeId = 0
  private showMenu: boolean = false
  private x: number = 0
  private y: number = 0

  private nodeCounters: Object = {
    sequences: 0,
    paths: 0,
    endPaths: 0,
    modules: 0,
    switchProducers: 0,
    psets: 0,
    tasks: 0,
    condTasks: 0,
    services: 0,
    streams: 0,
    datasets: 0,
    esproducers: 0,
    essources: 0,
    params: 0,
  }

  private iconTypes: Object = {
    sequences: 'mdi-view-sequential',
    modules: 'mdi-view-module',
    paths: 'mdi-filmstrip',
    endpaths: 'mdi-map-marker-path',
    pset: 'mdi-format-list-bulleted',
    tasks: 'mdi-sort-reverse-variant',
    conditionaltasks: 'mdi-sort-reverse-variant',
    switchproducers: 'mdi-light-switch',
    edalias: 'mdi-content-copy',
    esproducers: 'mdi-hammer-wrench',
    essources: 'mdi-source-merge',
    services: 'mdi-room-service',
    stream: 'mdi-sine-wave',
    dataset: 'mdi-database',
  }

  private iconColors: Object = {
    sequences: 'red',
    paths: 'green',
    endpaths: 'green',
    pset: 'orange',
    tasks: 'blue',
    conditionaltasks: 'blue',
    esproducers: '#E91E63',
    essources: '#1DE9B6',
    services: '#D84315',
    stream: 'lightblue',
    dataset: '#4A148C',
  }

  private nodeTypeTab: Object = {
    paths: 0,
    endpaths: 1,
    sequences: 2,
    modules: 3,
    esproducers: 4,
    essources: 5,
    switchproducers: 6,
    pset: 7,
    tasks: 8,
    conditionaltasks : 9,
    services: 10,
    dataset: 11,
    stream: 12,
  }

  //Vuex getters
  private getOpenFileContent!: any[]
  private getConfiguration!: any[] // are assigned via mapState
  private getConfigNodesMap!: Object
  private getIDCounter!: number

  //Vuex actions
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private setStartLoadingConfig!: (payload: boolean) => Promise<any>
  private setConfigLoaded!: (payload: boolean) => Promise<any>
  private clearStoreState!: () => Promise<any>
  private setSelectedNodeViaID!: (payload: {
    selectedNodeId: number
    forceOpenNode: boolean
  }) => Promise<any>
  private fetchCfgFromFileOrLocalServer!: (payload: {
    fromFile: boolean
    fileData: any
  }) => Promise<any>
  private createTreeRefsMap!: (payload: Object) => Promise<any>
  private createConfigNodesMap!: (payload: Object) => Promise<any>
  private createTopLevelNodeNameToIds!: (payload: Object) => Promise<any>
  private createTopLevelNodeTypeToIds!: (payload: Object) => Promise<any>
  private createTopLevelNodeNameReferenceIDsMap!: (
    payload: Object
  ) => Promise<any>
  private createTopLevelDatasetNameToIds!: (payload: Object) => Promise<any>
  private createTopLevelStreamNameToIds!: (payload: Object) => Promise<any>
  private createTopLevelDatasetNameReferenceIDsMap!: (
    payload: Object
  ) => Promise<any>
  private createTopLevelStreamNameReferenceIDsMap!: (
    payload: Object
  ) => Promise<any>
  private createTopLevelModuleNameChildrenIDsMap!: (
    payload: Object
  ) => Promise<any>
  private createRootNodeIds!: (payload: Object) => Promise<any>
  private setInitialIDCounter!: (payload: number) => Promise<any>
  private createObjectReferences!: () => Promise<any>

  private activeTab: any = null

  private tabNames: Array<string> = [
    'Paths',
    'End Paths',
    'Sequences',
    'Modules',
    'ESProducers',
    'ESSources',
    'Switch Producers',
    'PSets',
    'Tasks',
    'Conditional Tasks',
    'Services',
    'Datasets',
    'Streams',
  ]

  private tabNameToType: Object = {
    Paths: 'pts',
    'End Paths': 'endpts',
    Sequences: 'seqs',
    Modules: 'mods',
    ESProducers: 'esprods',
    ESSources: 'essour',
    'Switch Producers': 'switchprods',
    PSets: 'psets',
    Tasks: 'tsks',
    'Conditional Tasks': 'condtsks',
    Services: 'serv',
    Datasets: 'streams',
    Streams: 'datasets',
  }

  get tabItems() {
    return [
      this.getConfigNodesMap[this.pathsId].children,
      this.getConfigNodesMap[this.endPathsId].children,
      this.getConfigNodesMap[this.sequencesId].children,
      this.getConfigNodesMap[this.modulesId].children,
      this.getConfigNodesMap[this.esProducersId].children,
      this.getConfigNodesMap[this.esSourcesId].children,
      this.getConfigNodesMap[this.switchProducersId].children,
      this.getConfigNodesMap[this.psetsId].children,
      this.getConfigNodesMap[this.tasksId].children,
      this.getConfigNodesMap[this.condTasksId].children,
      this.getConfigNodesMap[this.servicesId].children,
      this.getConfigNodesMap[this.datasetsId].children,
      this.getConfigNodesMap[this.streamsId].children,
    ]
  }

  public checkIfNodeIsParamType(itemType: string): boolean {
    if (
      itemType.indexOf('cms.') != -1 ||
      itemType == 'string' ||
      itemType == 'int32' ||
      itemType == 'double' ||
      itemType == 'VPSet' ||
      itemType == 'PSet' ||
      itemType == 'untracked.PSet' ||
      itemType == 'untracked.VPSet' ||
      itemType == 'InputTag'
    )
      return true
    else return false
  }

  public clearNodeID() {
    //console.log('AAA')
    this.fetchNodeById(1)
  }

  async fetchNodeById(itemId: number): Promise<void> {
    /*  console.log('ITEM ID: ' + itemId)
    console.log('NODE: ' + JSON.stringify(this.getConfigNodesMap[itemId])) */
    if (
      this.getConfigNodesMap[itemId] == undefined ||
      this.checkIfNodeIsParamType(this.getConfigNodesMap[itemId].type) //don't fetch params
    )
      return
    if (this.getConfigNodesMap[itemId].rootNodeId != itemId) {
      itemId = this.getConfigNodesMap[itemId].rootNodeId
      //console.log('ROOT NODE ID: ' + itemId)

      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
    } else
      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
  }

  rightMouseClickedTab(e: any, itemType: string, itemId: number) {
    e.preventDefault()

    this.rightClickNodeType = itemType
    this.rightClkNodeId = itemId
    this.showMenu = false
    this.x = e.clientX
    this.y = e.clientY

    this.$nextTick(() => {
      this.showMenu = true
      //console.log('SET TRUE')
    })
  }

  rightMouseClicked(value: Object) {
    console.log(value)

    this.rightClickNodeType = value['rightClickNodeType']
    this.rightClkNodeId = value['rightClkNodeId']
    this.showMenu = value['showMenu']
    this.x = value['x']
    this.y = value['y']

    this.$nextTick(() => {
      this.showMenu = true
      //console.log('SET TRUE')
    })
  }

  public testFunction() {
    this.$store.dispatch('testAction', null)
  }

  public parseAllNodes() {
  
    let ret = TreeParser.parseContainerType(
      this.getConfiguration['seqs'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters,
      "Sequences","seqs","sequences","sequences","sequencesId"
    )
    
    this.sequencesId = ret['sequencesId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['sequences'] = this.sequencesId
    //console.log('NODE COUNTERS: ' + JSON.stringify(this.nodeCounters))
    
    ret = TreeParser.parseContainerType(
      this.getConfiguration['paths'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters,
      "Paths","pts","paths","paths","pathsId"
    )


    this.pathsId = ret['pathsId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['paths'] = this.pathsId
    //console.log('NODE COUNTERS: ' + JSON.stringify(this.nodeCounters))
    ret = TreeParser.parseContainerType(
      this.getConfiguration['endpaths'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters,
      "End Paths","endpts","endpaths","endPaths","endPathsId"
    )
    this.endPathsId = ret['endPathsId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['endpaths'] = this.endPathsId
    //console.log('NODE COUNTERS: ' + JSON.stringify(this.nodeCounters))

    ret = TreeParser.parseModules(
      this.getConfiguration['mods'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.topLevelModuleNameToChildrenIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.modulesId = ret['modulesId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['mods'] = this.modulesId

    ret = TreeParser.parseSwitchProducers(
      this.getConfiguration['switchprods'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.switchProducersId = ret['switchProducersId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['switchprods'] = this.switchProducersId

    ret = TreeParser.parsePSets(
      this.getConfiguration['psets'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.psetsId = ret['psetsId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['psets'] = this.psetsId

    ret = TreeParser.parseContainerType(
      this.getConfiguration['conditionaltasks'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters,
      "Conditional Tasks","condtsks","conditionaltasks","condTasks","condTasksId"
    )
    this.condTasksId = ret['condTasksId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['condtasks'] = this.condTasksId

    ret = TreeParser.parseContainerType(
      this.getConfiguration['tasks'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters,
      "Tasks","tsks","tasks","tasks","tasksId"
    )
    this.tasksId = ret['tasksId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['tasks'] = this.tasksId

    ret = TreeParser.parseESProducers(
      this.getConfiguration['esprods'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.esProducersId = ret['esProducersId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['esprods'] = this.esProducersId

    ret = TreeParser.parseESSources(
      this.getConfiguration['essources'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.esSourcesId = ret['esSourcesId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['essources'] = this.esSourcesId

    ret = TreeParser.parseServices(
      this.getConfiguration['services'],
      this.configNodesMap,
      this.topLevelNodeNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )
    this.servicesId = ret['servicesId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['services'] = this.servicesId

    if(this.getConfiguration['psets']['datasets'] != undefined){
    ret = TreeParser.parseDatasets(
      this.getConfiguration['psets']['datasets'],
      this.configNodesMap,
      this.topLevelDatasetNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelNodeNameReferenceIDsMap,
      this.topLevelDataSetsNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )}
    this.datasetsId = ret['datasetsId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['datasets'] = this.datasetsId

    if(this.getConfiguration['psets']['streams'] != undefined){
    ret = TreeParser.parseStreams(
      this.getConfiguration['psets']['streams'],
      this.configNodesMap,
      this.topLevelStreamNameToIdMap,
      this.topLevelNodeTypeToIdMap,
      this.topLevelDataSetsNameReferenceIDsMap,
      this.topLevelStreamNameReferenceIDsMap,
      this.idCounter,
      this.nodeCounters
    )}
    this.streamsId = ret['streamsId']
    this.idCounter = ret['idCounter']
    this.rootNodeIds['streams'] = this.streamsId
  }

  async fetchConfiguration(): Promise<void> {
    this.setStartLoadingConfig(true)
    this.setConfigLoaded(false)
    this.clearStoreState()

    Promise.all([
      await this.fetchCfgFromFileOrLocalServer({
        fromFile: false,
        fileData: null,
      }), // note the "await"
    ])
      .catch((err) => {
        console.log(err)
      })
      .finally(async () => {
        this.loadConfiguration()
      })
  }

  public loadConfiguration(): void {
    //reset maps and ID counters
    this.configNodesMap = {}
    this.topLevelNodeNameToIdMap = {}
    this.topLevelNodeTypeToIdMap = {}
    this.topLevelNodeNameReferenceIDsMap = {}
    //Datasets and streams
    this.topLevelDatasetNameToIdMap = {}
    this.topLevelStreamNameToIdMap = {}
    this.topLevelDataSetsNameReferenceIDsMap = {}
    this.topLevelStreamNameReferenceIDsMap = {}
    //Module children IDs
    this.topLevelModuleNameToChildrenIDsMap = {}
    this.rootNodeIds = {}
    this.idCounter = 0

    let t0 = performance.now()

    this.parseAllNodes()
    this.createTreeRefsMap(this.treeRefsMap)
    //Sequences, Modules, Paths etc.
    this.createConfigNodesMap(this.configNodesMap)
    this.createTopLevelNodeNameToIds(this.topLevelNodeNameToIdMap)
    this.createTopLevelNodeTypeToIds(this.topLevelNodeTypeToIdMap)
    this.createTopLevelNodeNameReferenceIDsMap(
      this.topLevelNodeNameReferenceIDsMap
    )
    //Datasets and streams
    this.createTopLevelDatasetNameToIds(this.topLevelDatasetNameToIdMap)
    this.createTopLevelStreamNameToIds(this.topLevelStreamNameToIdMap)
    this.createTopLevelDatasetNameReferenceIDsMap(
      this.topLevelDataSetsNameReferenceIDsMap
    )
    /*     console.log(
      'DATESET REFERENCES' +
        JSON.stringify(this.topLevelDataSetsNameReferenceIDsMap)
    ) */
    this.createTopLevelStreamNameReferenceIDsMap(
      this.topLevelStreamNameReferenceIDsMap
    )
    //Module children
    this.createTopLevelModuleNameChildrenIDsMap(
      this.topLevelModuleNameToChildrenIDsMap
    )
    this.createRootNodeIds(this.rootNodeIds)

    //initilaize id counter in the store so other components can get/modify it
    this.setInitialIDCounter(this.idCounter)
    this.createObjectReferences()
    this.setStartLoadingConfig(false)
    this.setConfigLoaded(true)

    let t1 = performance.now()

    this.setSnackBarText({
      snackBarText:
        'Configuration successfully loaded! It took: ' +
        Math.round(t1 - t0) / 1000 +
        ' seconds',
      snackBarColor: 'green',
    })
  }

  async fetchConfigurationFromFile(fileContent: any): Promise<void> {
    //reset maps and ID counters
    this.configNodesMap = {}
    this.topLevelNodeNameToIdMap = {}
    this.topLevelNodeTypeToIdMap = {}
    this.topLevelNodeNameReferenceIDsMap = {}
    //Datasets and streams
    this.topLevelDatasetNameToIdMap = {}
    this.topLevelStreamNameToIdMap = {}
    this.topLevelDataSetsNameReferenceIDsMap = {}
    this.topLevelStreamNameReferenceIDsMap = {}
    //Module children IDs
    this.topLevelModuleNameToChildrenIDsMap = {}
    this.rootNodeIds = {}
    this.idCounter = 0

    this.clearStoreState()
    //console.log('FILE CONTENT: ' + fileContent)
    Promise.all([
      await this.fetchCfgFromFileOrLocalServer({
        fromFile: true,
        fileData: fileContent,
      }), // note the "await"
    ])
      .catch((err) => {
        console.log(err)
      })
      .finally(async () => {
        this.loadConfiguration()
        /*     console.log(
        'configNodesMap size' + sizeof(this.configNodesMap)
      ) */
      })
  }

  created() {
    this.$root.$refs.TreeView = this

    // Make a request for config parts
    if (globalThis.devEnvironment) this.fetchConfiguration()
  }

  mounted() {}

  updated() {
    this.$root.$refs.searchNodesRef = this.$refs.searchNodesRef
    this.$root.$refs.nodeTabsRef = this.$refs.nodeTabsRef
    //console.log('this.$root.$refs.searchNodesRef ' + this.$refs.searchNodesRef)
    //console.log('this.$root.$refs.nodeTabsRef ' + this.$refs.nodeTabsRef)
  }
}
